<template>
  <ul class="bp-dims">
    <li
      v-for="item in rows"
      :key="item.label"
      class="bp-dims__item"
    >
      <div
        class="bp-dims__measure"
        aria-hidden="true"
      >
        <span class="bp-dims__end" />
        <span class="bp-dims__line" />
        <span class="bp-dims__end" />
      </div>
      <p class="bp-dims__value">
        <span class="sr-only">{{ item.spoken }}</span>
        <span
          class="bp-dims__odo"
          aria-hidden="true"
        >
          <span
            v-for="(col, i) in item.cols"
            :key="i"
            class="bp-dims__col"
          >
            <span
              class="bp-dims__strip"
              :style="{ '--n': col.length - 1 }"
            >
              <span
                v-for="(digit, j) in col"
                :key="j"
              >{{ digit }}</span>
            </span>
          </span>
          <span v-if="item.suffix">{{ item.suffix }}</span>
        </span>
      </p>
      <p class="bp-dims__label">
        {{ item.label }}
      </p>
    </li>
  </ul>
</template>

<script setup lang="ts">
interface Dimension {
  value: number
  label: string
  spoken: string
  suffix?: string
}

const props = defineProps<{ items: Dimension[] }>()

// Each column is an odometer strip: it rolls through every count it passes,
// so the digit it lands on is the column's place value of the final number.
const rows = computed(() => props.items.map((item) => {
  const digits = String(item.value).length
  const cols = Array.from({ length: digits }, (_, place) => {
    const steps = Math.floor(item.value / 10 ** (digits - 1 - place))
    return Array.from({ length: steps + 1 }, (_, k) => k % 10)
  })
  return { ...item, cols }
}))
</script>
